import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  styles: {
    global: {
      body: {
        overflow: 'auto !important',
      },
    },
  },
  components: {
    // This is an example for the Accordion component.
    // You can identify the correct component using your browser's dev tools
    // and looking for a more semantic class name like `chakra-accordion__item`.
    Accordion: {
      baseStyle: {
        container: { // This targets the AccordionItem
          '&:last-of-type': {
            borderBottomWidth: 0,
          },
        },
      },
    },
  },
});

export default theme
